import React from "react";
import { Link } from "react-router-dom";
import { SERVICES } from "../data/site";

export default function Services() {
  return (
    <div data-testid="services-page">
      <header className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-12 md:pb-16">
        <p className="label mb-4">Studio Programs</p>
        <h1 className="serif text-5xl md:text-7xl tracking-tight font-light leading-[1.02]">
          Services.
        </h1>
        <p className="mt-6 max-w-2xl text-[hsl(var(--ink-soft))] text-lg leading-relaxed">
          Beyond original work, the studio offers a range of programming for
          schools, events, and private clients.
        </p>
      </header>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10">
          {SERVICES.map((s, i) => (
            <article
              key={s.title}
              className="border-t border-border pt-6 flex items-start gap-6"
              data-testid={`service-${i}`}
            >
              <span className="serif text-2xl text-[hsl(var(--accent))] w-12">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div>
                <h3 className="serif text-2xl md:text-3xl">{s.title}</h3>
                <p className="mt-2 text-[hsl(var(--ink-soft))] leading-relaxed">
                  {s.blurb}
                </p>
                {s.link &&
                  (s.internal ? (
                    <Link
                      to={s.link}
                      className="mt-3 inline-block label link-underline"
                      data-testid={`service-link-${i}`}
                    >
                      {s.link.startsWith("/contact") ? "Inquire →" : "Explore & book →"}
                    </Link>
                  ) : (
                    <a
                      href={s.link}
                      target="_blank"
                      rel="noreferrer"
                      className="mt-3 inline-block label link-underline"
                      data-testid={`service-link-${i}`}
                    >
                      Visit shop →
                    </a>
                  ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
